<!-- @format -->

<ng-container *transloco="let t">
  <fudis-grid>
    <fudis-grid-item>
      <fudis-heading [level]="2">{{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.STUDY_PROGRESS") }}</fudis-heading>
      <fudis-dl [columns]="{ sm: 1, md: 2 }">
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.STUDY_RIGHT')" />
          <fudis-dd [contentText]="automaticallyFilledApplicationFields.educationId | education | async | entityName | localizedString" />
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.STUDY_RIGHT_VALIDITY')" />
          <fudis-dd [contentText]="automaticallyFilledApplicationFields.studyRightValidity | localDateRange" />
        </fudis-dl-item>
        @if (automaticallyFilledApplicationFields.previousExtensions?.length > 0) {
          <fudis-dl-item>
            <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.PREVIOUSLY_GRANTED_EXTENSIONS')" />
            <fudis-dd>
              <sis-extension-info [extensions]="automaticallyFilledApplicationFields.previousExtensions" />
            </fudis-dd>
          </fudis-dl-item>
        }
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.STUDY_TERMS_ATTENDING')" />
          <fudis-dd>
            <sis-text-with-default-missing-value [value]="automaticallyFilledApplicationFields.usedAttendanceTerms?.toString()" />
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.STUDY_TERMS_NONATTENDING')" />
          <fudis-dd>
            <sis-text-with-default-missing-value [value]="automaticallyFilledApplicationFields.usedAbsenceTerms?.toString()" />
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.STUDY_TERMS_STATUTORY_ABSENCES')" />
          <fudis-dd>
            <sis-text-with-default-missing-value [value]="automaticallyFilledApplicationFields.usedStatutoryAbsenceTerms?.toString()" />
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.STUDY_TERMS_NO_REGISTRATION')" />
          <fudis-dd>
            <sis-text-with-default-missing-value [value]="automaticallyFilledApplicationFields.termsWithoutRegistration?.toString()" />
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.EXTENSION_APPLICATION.ATTAINED_AND_REQUIRED_CREDITS')" />
          <fudis-dd>
            <sis-education-phase-progress [educationPhaseProgress]="automaticallyFilledApplicationFields.phase1Progress" />
          </fudis-dd>
          <fudis-dd>
            <sis-education-phase-progress [educationPhaseProgress]="automaticallyFilledApplicationFields.phase2Progress" />
          </fudis-dd>
        </fudis-dl-item>
        <fudis-dl-item>
          <fudis-dt [contentText]="t('STUDENT_APPLICATIONS.AVERAGE_CREDITS_PER_STUDY_TERM')" />
          <fudis-dd>{{ creditsPerTerm | decimalNumber }} {{ t("CREDITS") }}</fudis-dd>
        </fudis-dl-item>
      </fudis-dl>
    </fudis-grid-item>

    <fudis-grid-item>
      <fudis-heading [level]="3">{{ t("STUDENT_APPLICATIONS.EXTENSION_APPLICATION.SPENT_STUDY_TERMS") }}</fudis-heading>
      <sis-attained-credits-by-study-term [attainedCredits]="attainedCreditsByStudyTerm" />
    </fudis-grid-item>

    <fudis-grid-item>
      <fudis-heading [level]="3">{{ t("STUDENT_APPLICATIONS.EXTENSION_APPLICATION.PLANNED_STUDIES") }}</fudis-heading>
      <fudis-grid>
        <fudis-body-text [variant]="'lg-light'">
          {{ t("PROFILE.APPLICATIONS.EXTENSION_APPLICATION.PLANNED_STUDIES_DESCRIPTION") }}
        </fudis-body-text>
        <sis-planned-studies-by-study-term [plannedStudies]="plannedStudies" />
      </fudis-grid>
    </fudis-grid-item>
  </fudis-grid>
</ng-container>
